module.exports = __webpack_public_path__ + "static/product-1-20cd0b640e343c1461f73be925a1b4fe.png";